/* @flow weak */
import { keys, uniqueId } from 'lodash';
import cx from 'classnames';
import enumerate from 'lib/enumerate';
import MMYYInput from 'payments/components/MMYYInput.jsx';
import CardNumberInput from 'payments/components/CardNumberInput.jsx';
import Glyph from 'components/Glyph.jsx';
import Input from 'components/Input.jsx';
import Label from 'components/Label.jsx';
import React from 'react';
import TrackedInput from 'components/TrackedInput.jsx';

import './styles/CardInput.scss';

const INPUTS = enumerate([
  'CARD_CVC',
  'CARD_EXPIRY',
  'CARD_NUMBER',
  'CARD_ZIP',
]);

const INPUT_VALIDATIONS = {
  [INPUTS.CARD_CVC]: {
    getValidator: () => window.Stripe.card.validateCVC,
    key: 'cvc',
  },
  [INPUTS.CARD_EXPIRY]: {
    getValidator: () => window.Stripe.card.validateExpiry,
    key: 'expiry',
  },
  [INPUTS.CARD_NUMBER]: {
    getValidator: () => window.Stripe.card.validateCardNumber,
    key: 'number',
  },
  [INPUTS.CARD_ZIP]: {
    getValidator: () => value => value.length > 0,
    key: 'zip',
  },
};

const CardInput = React.createClass({
  propTypes: {
    className: React.PropTypes.string,
    id: React.PropTypes.string,
    label: React.PropTypes.any,
    labelHidden: React.PropTypes.bool,
    placeholder: React.PropTypes.string,
    values: React.PropTypes.object,
    onInvalid: React.PropTypes.func.isRequired,
    onValid: React.PropTypes.func.isRequired,
  },

  contextTypes: {
    eventScreenName: React.PropTypes.string,
  },

  getDefaultProps() {
    return {
      placeholder: 'Enter your debit or credit card number to pay',
    };
  },

  getInitialState() {
    return {
      showCardInfo: !!this.props.values,
      card: Object.assign({
        cvc: {},
        expiry: {},
        number: {},
        zip: {},
      }, this.props.values),
    };
  },

  componentWillMount() {
    this.setState({ id: uniqueId('id-') });
  },

  onInputChange(input, value) {
    const validation = INPUT_VALIDATIONS[input];
    const validator = validation.getValidator();

    const { card } = this.state;
    card[validation.key] = { value, isValid: validator(value) };

    this.setState({ card }, this.informParentsOfFormStatus);
  },

  handleInputFocus() {
    this.setState({ showCardInfo: true });
  },

  informParentsOfFormStatus() {
    const cardKeys = keys(this.state.card);
    const isValid = cardKeys.every(key => this.state.card[key].isValid);

    if (isValid) {
      this.props.onValid(this.state.card);
    } else {
      this.props.onInvalid(this.state.card);
    }
  },

  renderLabel() {
    const { label } = this.props;

    if (label) {
      return (
        <Label
          htmlFor={this.state.id}
          hidden={this.props.labelHidden}
          onClick={this.handleInputFocus}>
          {label}
        </Label>
      );
    } else {
      return null;
    }
  },

  renderCardInputs() {
    if (!this.state.showCardInfo) {
      return (
        <div className="CardInput-inputs">
          <Input
            data-test-selector="card_input_placeholder"
            placeholder={this.props.placeholder}
            className="CardInput-cardPlaceholder CardInput-input"
            onFocus={this.handleInputFocus}
          />
        </div>
      );
    }
    return (
      <div className="CardInput-inputs">
        <CardNumberInput
          data-test-selector="card_number_input"
          autoFocus
          id={this.state.id}
          value={this.state.card.number.value || ''}
          className={cx('CardInput-cardNumber CardInput-input', {
            error: this.state.card.number.isValid === false,
          })}
          onChange={value => this.onInputChange(INPUTS.CARD_NUMBER, value)}
          onFocus={() => this.setState({ focus: true })}
          onBlur={() => this.setState({ focus: false })}
        />

        <MMYYInput
          data-test-selector="card_expiration_input"
          maxLength="7"
          placeholder="MM/YY"
          value={this.state.card.expiry.value || ''}
          className={cx('CardInput-expiry CardInput-input', {
            error: this.state.card.expiry.isValid === false,
          })}
          onChange={(value) => this.onInputChange(INPUTS.CARD_EXPIRY, value)}
          onFocus={() => this.setState({ focus: true })}
          onBlur={() => this.setState({ focus: false })}
        />

        <TrackedInput
          data-test-selector="card_cvc_input"
          type="tel"
          autoComplete="cc-csc"
          maxLength="4"
          pattern="[\d]{3,4}"
          placeholder="CVC"
          value={this.state.card.cvc.value || ''}
          className={cx('CardInput-verificationCode CardInput-input cc-cvc cc-csc', {
            error: this.state.card.cvc.isValid === false,
          })}
          onChange={({ target }) => this.onInputChange(INPUTS.CARD_CVC, target.value)}
          onFocus={() => this.setState({ focus: true })}
          onBlur={() => this.setState({ focus: false })}
          eventScreenName={this.context.eventScreenName}
          eventElementName="add_cvv"
        />

        <TrackedInput
          data-test-selector="card_zip_input"
          type="tel"
          autoComplete="postal-code"
          maxLength="5"
          pattern="[\d]{5}"
          placeholder="ZIP"
          value={this.state.card.zip.value || ''}
          className={cx('CardInput-zip CardInput-input postal-code', {
            error: this.state.card.zip.isValid === false,
          })}
          onChange={({ target }) => this.onInputChange(INPUTS.CARD_ZIP, target.value)}
          onFocus={() => this.setState({ focus: true })}
          onBlur={() => this.setState({ focus: false })}
          eventScreenName={this.context.eventScreenName}
          eventElementName="add_zip"
        />
      </div>
    );
  },

  render() {
    return (
      <div>
        {this.renderLabel()}
        <div
          className={cx('CardInput', this.props.className, {
            'CardInput-focus': this.state.focus,
          })}>
          {this.renderCardInputs()}
          <Glyph name="lock-stroke" className="CardInput-icon" size="small" color="koala" />
        </div>
      </div>
    );
  },
});

export default CardInput;



// WEBPACK FOOTER //
// ./src/payments/components/CardInput.jsx